import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-blog-grid',
  templateUrl: './blog-grid.component.html',
  styleUrl: './blog-grid.component.css'
})
export class BlogGridComponent {
  blogs = [

    {
      image: "blog-1.jpg",
      category: "Web Design",
      author: "Nadia Farooq",
      date: "08 Jun, 2025",
      title: "5 Web Design Trends to Watch in 2025",
      desc: "Discover the latest UI/UX techniques and creative inspirations that are shaping modern websites."
    },

    {
      image: "blog-2.jpg",
      category: "Digital Marketing",
      author: "Ali Raza",
      date: "22 May, 2025",
      title: "Boost SEO with These Proven Content Strategies",
      desc: "Learn how strategic content planning and SEO optimization can help drive organic traffic."
    },

    {
      image: "blog-3.jpg",
      category: "App Development",
      author: "Sana Qureshi",
      date: "15 May, 2025",
      title: "Essential Features Every Modern App Must Include",
      desc: "From user onboarding to dark mode, here are must-have features for high-performing mobile apps."
    },

    {
      image: "blog-4.jpg",
      category: "SEO",
      author: "Usman Khan",
      date: "01 May, 2025",
      title: "How to Rank Faster on Google",
      desc: "SEO strategies that help websites rank faster on search engines."
    }

  ];


  categories = [
    "Web Design",
    "Web Development",
    "Keyword Research",
    "Email Marketing",
    "Digital Marketing"
  ];


  recentPosts = [
    {
      image: "post-1.jpg",
      title: "Top Tips for Clean Website Layouts"
    },

    {
      image: "post-2.jpg",
      title: "Boost Engagement with Interactive Elements"
    },

    {
      image: "post-3.jpg",
      title: "Choosing the Right Typography for Web"
    },

    {
      image: "post-4.jpg",
      title: "Designing for Mobile What to Know"
    }
  ];


  tags = [
    "Design",
    "Development",
    "Marketing",
    "SEO",
    "Writing",
    "Consulting"
  ];

  // OWl Slider
  brandsCarousel: OwlOptions = {
  loop: true,
  dots: false,
  margin:50,
  nav:false,
  autoplay:true,
  autoplaySpeed: 2000,
  navSpeed: 2000,
  items: 6,
  navText: ['<i class="bi bi-arrow-left-short"></i>', '<i class="bi bi-arrow-right-short"></i>'],
}

brandStore = [
  {img: "vendor-1.jpg"},
  {img: "vendor-2.jpg"},
  {img: "vendor-3.jpg"},
  {img: "vendor-4.jpg"},
  {img: "vendor-5.jpg"},
  {img: "vendor-6.jpg"}
];
}
